var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHomeIconSmall = function SvgHomeIconSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    fillRule: "evenodd",
    d: "m17.5 7.31-5.816-5.816a2.5 2.5 0 0 0-3.536 0L2.5 7.142v12.096h5.833v-5a1.667 1.667 0 1 1 3.334 0v5H17.5zM9.327 2.672l-5.16 5.16v9.74h2.5v-3.334a3.333 3.333 0 1 1 6.666 0v3.333h2.5v-9.57l-5.328-5.329a.833.833 0 0 0-1.178 0",
    clipRule: "evenodd"
  })));
};
export default SvgHomeIconSmall;